import analytics from '../analytics/analytics';
export default class SentenceArrayBuilder {
  constructor() {
    this.urlRegex = /https?:\/\/\S+/gi;
    this.sentenceQueue = [];
    this.currentSentence = '';
    this.terminationChars = ['.', '?', '!', ';', '。'];
  }
  addChunk(textChunk) {
    try {
      if (textChunk === 'STREAMING_ENDED') {
        this.addRemainingSentence();
        return;
      }
      this.currentSentence += textChunk;
      let startIndex = 0;
      for (let i = 0; i < this.currentSentence.length; i++) {
        if (this.isTerminationChar(this.currentSentence[i], i)) {
          const completeSentence = this.currentSentence.substring(startIndex, i + 1);
          if (completeSentence.length > 0) {
            this.sentenceQueue.push(completeSentence.trim());
            startIndex = i + 1;
          }
        }
      }
      this.currentSentence = this.currentSentence.substring(startIndex);
    } catch (e) {
      analytics.logError({
        message: 'Error adding chunk to SentenceArrayBuilder queue',
        error: JSON.stringify(e)
      });
    }
  }
  getSentenceQueue() {
    return this.sentenceQueue;
  }
  reset() {
    this.currentSentence = '';
    this.sentenceQueue = [];
  }
  dequeueAllSentences() {
    const processedSentences = this.sentenceQueue.map(sentence => {
      return this.processURLs(sentence);
    });
    const joinedSentences = processedSentences.join(' ');
    this.sentenceQueue = [];
    return joinedSentences.trim();
  }
  addRemainingSentence() {
    if (this.currentSentence.length > 0) {
      this.sentenceQueue.push(this.currentSentence);
      this.currentSentence = '';
    }
  }
  isTerminationChar(char, index) {
    if (!this.terminationChars.includes(char)) {
      return false;
    }
    // For periods, check if it's followed by a space, a newline, is the last character,
    // or is at the end of the current chunk
    if (char === '.') {
      const nextChar = this.currentSentence[index + 1];
      return nextChar === ' ' || nextChar === '\n' || nextChar === undefined || index === this.currentSentence.length - 1;
    }
    // For other termination characters (e.g., ?, !), keep the existing logic
    return index === 0 || !/\d/.test(this.currentSentence[index - 1]);
  }
  processURLs(sentence) {
    return sentence.replace(this.urlRegex, urlMatch => {
      // Check if the URL is followed by a period that's a sentence terminator
      let url = urlMatch;
      const isEndOfSentence = url[url.length - 1] === '.';
      if (isEndOfSentence) {
        // Exclude the final period from the URL processing
        url = url.slice(0, -1);
      }
      // Convert the URL
      const processedUrl = url.replace(/https?:\/\//gi, '') // Remove the protocol
      .replace(/\./g, ' dot ') // Replace '.' with ' dot '
      .replace(/\//g, ' slash '); // Replace '/' with ' slash '
      return isEndOfSentence ? processedUrl + '.' : processedUrl;
    });
  }
  destroy() {
    // Nullify properties to ensure the instance can be garbage collected
    this.sentenceQueue = [];
    this.currentSentence = '';
  }
}